
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import template from './demo/demo.twig';
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import demoSource from '!!raw-loader!./demo/demo.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Components/Footnote/Footnote" argTypes={{
      count: {
        type: {
          name: 'number'
        }
      },
      id: {
        type: {
          name: 'number'
        }
      },
      content: {
        type: {
          name: 'string'
        }
      }
    }} mdxType="Meta" />
    <h1>{`Footnote`}</h1>
    <p>{`Used for displaying the content of a footnote.`}</p>
    <p>{`Renders as a list item (`}<inlineCode parentName="p">{`<li>`}</inlineCode>{`). Expected to be wrapped in a `}<a parentName="p" {...{
        "href": "/docs/components-footnote-footnote-group--basic"
      }}>{`Footnote Group`}</a>{` and paired with a `}<a parentName="p" {...{
        "href": "/docs/components-footnote-footnote-link--basic"
      }}>{`Footnote Link`}</a>{`.`}</p>
    <h2>{`Basic usage`}</h2>
    <Canvas mdxType="Canvas">
  <Story name="Basic" args={{
        count: 1
      }} parameters={{
        docs: {
          source: {
            code: demoSource
          }
        }
      }} mdxType="Story">
    {args => template(args)}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <p><inlineCode parentName="p">{`count`}</inlineCode>{` (number) the number of the current footnote we're on (e.g. this is the second footnote in the document)`}</p>
    <h2>{`Template Blocks`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`content`}</inlineCode>{` The footnote contents`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`id`}</inlineCode>{` (string) a unique ID for a footnote. Defaults to the `}<inlineCode parentName="li">{`count`}</inlineCode>{` but can be customized if there are multiple sets of footnotes on one page`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const basic = (args => template(args));
basic.storyName = 'Basic';
basic.args = {
  count: 1
};
basic.parameters = { storySource: { source: 'args => template(args)' }, ...{
  docs: {
    source: {
      code: demoSource
    }
  }
} };

const componentMeta = { title: 'Components/Footnote/Footnote', argTypes: {
  count: {
    type: {
      name: 'number'
    }
  },
  id: {
    type: {
      name: 'number'
    }
  },
  content: {
    type: {
      name: 'string'
    }
  }
}, includeStories: ["basic"],  };

const mdxStoryNameToKey = {"Basic":"basic"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;